import { AppRoutes } from '../../App/routes';
import { systemBaseRoute } from 'cb-utils/consoleRouteUtils';

export const timersRoot = 'timers';
export const timersBaseRoute = `${AppRoutes.CONSOLE_BASE_ROUTE}${systemBaseRoute}/${timersRoot}`;
